import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { assetKeys } from '@/shared/lib/query/queryKeys';
import type { TagSource } from '@/shared/types/openmetadata';

import { updateColumnTags } from '@/features/asset-detail/api';

type UpdateColumnTagsParams = {
  tableFqn: string;
  columnName: string;
  tagFQNs: string[];
  source: TagSource;
};

export const useUpdateColumnTags = (entityType: string, tableFqn: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ tableFqn, columnName, tagFQNs, source }: UpdateColumnTagsParams) => {
      await updateColumnTags(tableFqn, columnName, tagFQNs, source);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: assetKeys.schema(entityType, tableFqn),
      });

      const title = variables.source === 'Classification' ? '태그 업데이트 완료' : '용어 업데이트 완료';
      const description =
        variables.source === 'Classification'
          ? `${variables.columnName} 컬럼의 태그가 성공적으로 업데이트되었습니다.`
          : `${variables.columnName} 컬럼의 용어가 성공적으로 업데이트되었습니다.`;

      notification.success({
        message: title,
        description,
        placement: 'bottomLeft',
        duration: 3,
      });
    },
    onError: (_error: Error, variables) => {
      const title = variables.source === 'Classification' ? '태그 업데이트 실패' : '용어 업데이트 실패';
      const description =
        variables.source === 'Classification'
          ? `${variables.columnName} 컬럼의 태그 업데이트에 실패했습니다.`
          : `${variables.columnName} 컬럼의 용어 업데이트에 실패했습니다.`;

      notification.error({
        message: title,
        description,
        placement: 'bottomLeft',
        duration: 5,
      });
    },
  });
};
